/**
 * useAuth Hook
 *
 * Separated from AuthContext.tsx for React Fast Refresh compatibility.
 * This prevents HMR invalidation loops when the context file is modified.
 */
import { useContext } from 'react';
import { AuthContext, AuthContextType } from './AuthContext';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
